


















































































import { Vue, Component } from 'vue-property-decorator';
import CardFormElement from '@/components/cards/CardFormElement.vue';
import draggable from 'vuedraggable';
import ElementBase from './ElementBase';

@Component({
    name: 'ElementInputMultiRange',
    components: {
        draggable,
        'card-form-element': CardFormElement,
    },
})
export default class ElementInputMultiRange extends ElementBase {
    collapsedOptions: {
        [id: number]: boolean;
    } = {};
    defaults: any = {
        placeholder: '',
    };

    collapse(id: number, state: boolean) {
        Vue.set(this.collapsedOptions, id, state);
    }

    addOption() {
        const option: any = {
            id: this.input.options ? this.input.options.length : 0,
            label: '',
            min: 0,
            max: 0,
            points: 0,
        };

        if (this.input.options) {
            this.input.options.push(option);
        } else {
            this.input.options = [option];
        }
    }

    removeOption(option: any) {
        if (this.input.options) {
            const index = this.input.options.indexOf(option);
            this.input.options.splice(index, 1);
        }
    }
}
